<template>
  <Header />
  <div class="contact-container">
    <div class="contact-header">
      <h1>İLETİŞİM</h1>
    </div>

    <div class="contact-content">
      <div class="map-container">
        <!-- Google Maps iframe -->
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3010.0498063675914!2d29.14242047604141!3d41.02416627134838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDAxJzI3LjAiTiAyOcKwMDgnNDIuMCJF!5e0!3m2!1str!2str!4v1711010590508!5m2!1str!2str"
          width="100%"
          height="475"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>

      <div class="info-container">
        <div class="contact-info">
          <h2>Bize Ulaşın</h2>
          <hr />
          <p><strong>Telefon:</strong> +90 542-223-39-96</p>
          <p><strong>İsim:</strong> Mustafa Çatakkaya</p>
          <p><strong>Telefon:</strong> +90 530-465-59-26</p>
          <p><strong>İsim:</strong> Mustafa Gürçay</p>
        </div>

        <div class="address-info">
          <h2>Adres</h2>
          <hr />
          <p>
            Cemil Meriç, Ayabakan Sokağı 3 34771
            Dudullu Osb/Ümraniye/İstanbul
          </p>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "ContactViews",
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  mounted() {
    document.title = "Ayyıldız Mobilya - İletişim";
    window.scrollTo({ top: 0, behavior: "smooth" }); // Sayfanın üstüne kaydır
  },
};
</script>
<style scoped>
/****** Genel Stil *******/
.contact-container {
  padding: 20px;
  max-width: 1360px;
  margin: auto;
}

.contact-header {
  text-align: center;
  margin-bottom: 40px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.contact-header h1 {
  font-size: 2.5rem;
  color: #333;
}

/****** İçerik Düzeni *******/
.contact-content {
  display: flex;
  gap: 30px;
}

.map-container {
  flex: 1;
  min-height: 400px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.info-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-info,
.address-info {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.contact-info h2,
.address-info h2 {
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #444;
}

.contact-info hr,
.address-info hr {
  border: none;
  height: 2px;
  background: #ddd;
  margin: 10px 0;
}

.contact-info p,
.address-info p {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
}

/****** Mobil Uyum *******/
@media (max-width: 768px) {
  .contact-content {
    flex-direction: column;
  }

  .map-container {
    height: auto;
  }
}
</style>
